// Variant Subtexts Data
// Update this file with your variant subtext mappings
// Format: Array of {id, product_id, option_name, option_value, subtext}

window.variantSubtextsData = [
  {
    "id": 14,
    "product_id": "7466959208542",
    "option_name": "Staff Length",
    "option_value": "1400mm",
    "subtext": "Height 159cm or less"
  },
  {
    "id": 15,
    "product_id": "7466959208542",
    "option_name": "Staff Length",
    "option_value": "1500mm",
    "subtext": "Height 160cm - 184cm"
  },
  {
    "id": 16,
    "product_id": "7466959208542",
    "option_name": "Staff Length",
    "option_value": "1600mm | Height 185cm - 194cm",
    "subtext": "Height 185cm - 194cm"
  },
  {
    "id": 17,
    "product_id": "7466959208542",
    "option_name": "Staff Length",
    "option_value": "1700mm | Height 195cm or more",
    "subtext": "195cm or more"
  },
  {
    "id": 19,
    "product_id": "7466959208542",
    "option_name": "Spokes",
    "option_value": "6 x Sushi Spokes",
    "subtext": "Great for Most People"
  },
  {
    "id": 20,
    "product_id": "7466959208542",
    "option_name": "Spokes",
    "option_value": "8 x Isis Spokes",
    "subtext": "Pro Users"
  },
  {
    "id": 18,
    "product_id": "7466959208542",
    "option_name": "Spokes",
    "option_value": "6 x Isis Spokes",
    "subtext": "Pro Users"
  },
  {
    "id": 21,
    "product_id": "7466959208542",
    "option_name": "Spokes",
    "option_value": "8 x Sushi Spokes",
    "subtext": "Great for Most People"
  },
  {
    "id": 22,
    "product_id": "7466960158814",
    "option_name": "Length",
    "option_value": "1400mm",
    "subtext": "Height 159cm or less"
  },
  {
    "id": 23,
    "product_id": "7466960158814",
    "option_name": "Length",
    "option_value": "1500mm",
    "subtext": "Height 160cm - 184cm"
  },
  {
    "id": 24,
    "product_id": "7466960158814",
    "option_name": "Length",
    "option_value": "1600mm",
    "subtext": "Height 185cm - 194cm"
  },
  {
    "id": 25,
    "product_id": "7466960158814",
    "option_name": "Length",
    "option_value": "1700mm",
    "subtext": "195cm or more"
  },
  {
    "id": 26,
    "product_id": "7466947215454",
    "option_name": "Staff Length",
    "option_value": "1700mm",
    "subtext": "195cm or more"
  },
  {
    "id": 27,
    "product_id": "7466947215454",
    "option_name": "Staff Length",
    "option_value": "1500mm",
    "subtext": "Height 160cm - 184cm"
  },
  {
    "id": 28,
    "product_id": "7466947215454",
    "option_name": "Staff Length",
    "option_value": "1400mm",
    "subtext": "Height 159cm or less"
  },
  {
    "id": 29,
    "product_id": "7466947215454",
    "option_name": "Staff Length",
    "option_value": "1600mm",
    "subtext": "Height 185cm - 194cm"
  },
  {
    "id": 30,
    "product_id": "7456242729054",
    "option_name": "Staff Length",
    "option_value": "1600mm",
    "subtext": "Height 185cm - 194cm"
  },
  {
    "id": 31,
    "product_id": "7456242729054",
    "option_name": "Staff Length",
    "option_value": "1500mm",
    "subtext": "Height 160cm - 184cm"
  },
  {
    "id": 32,
    "product_id": "7456242729054",
    "option_name": "Staff Length",
    "option_value": "1400mm",
    "subtext": "Height 159cm or less"
  },
  {
    "id": 33,
    "product_id": "7456242729054",
    "option_name": "Staff Length",
    "option_value": "1700mm",
    "subtext": "195cm or more"
  },
  {
    "id": 35,
    "product_id": "7429354455134",
    "option_name": "Staff Length",
    "option_value": "1500mm",
    "subtext": "Height 160cm - 184cm"
  },
  {
    "id": 36,
    "product_id": "7429354455134",
    "option_name": "Staff Length",
    "option_value": "1600mm",
    "subtext": "Height 185cm - 194cm"
  },
  {
    "id": 37,
    "product_id": "7429354455134",
    "option_name": "Staff Length",
    "option_value": "1700mm",
    "subtext": "195cm or more"
  },
  {
    "id": 38,
    "product_id": "7429354455134",
    "option_name": "Spokes - Type",
    "option_value": "2\" Sushi Roll",
    "subtext": "Great for Most People"
  },
  {
    "id": 39,
    "product_id": "7429354455134",
    "option_name": "Spokes - Type",
    "option_value": "Isis Weave",
    "subtext": "Pro Users"
  },
  {
    "id": 34,
    "product_id": "7429354455134",
    "option_name": "Staff Length",
    "option_value": "1400mm",
    "subtext": "Height 159cm or less"
  },
  {
    "id": 40,
    "product_id": "7481329483870",
    "option_name": "Type",
    "option_value": "Carbon Fibre",
    "subtext": "Most Popular"
  },
  {
    "id": 41,
    "product_id": "7481329483870",
    "option_name": "Type",
    "option_value": "Hybrid LED",
    "subtext": "Light up Ends"
  },
  {
    "id": 42,
    "product_id": "7481329483870",
    "option_name": "Staff Length",
    "option_value": "1400mm",
    "subtext": "Height 159cm or less"
  },
  {
    "id": 43,
    "product_id": "7481329483870",
    "option_name": "Staff Length",
    "option_value": "1500mm",
    "subtext": "Height 160cm - 184cm"
  },
  {
    "id": 44,
    "product_id": "7481329483870",
    "option_name": "Staff Length",
    "option_value": "1600mm",
    "subtext": "Height 185cm - 194cm"
  },
  {
    "id": 45,
    "product_id": "7481329483870",
    "option_name": "Staff Length",
    "option_value": "1700mm",
    "subtext": "195cm or more"
  },
  {
    "id": 46,
    "product_id": "7428023189598",
    "option_name": "Staff Length",
    "option_value": "1500mm",
    "subtext": "Height 160cm - 184cm"
  },
  {
    "id": 47,
    "product_id": "7428023189598",
    "option_name": "Staff Length",
    "option_value": "1600mm",
    "subtext": "Height 185cm - 194cm"
  },
  {
    "id": 48,
    "product_id": "7428023189598",
    "option_name": "Staff Length",
    "option_value": "1700mm",
    "subtext": "195cm or more"
  },
  {
    "id": 49,
    "product_id": "7428023189598",
    "option_name": "Staff Length",
    "option_value": "1400mm",
    "subtext": "Height 159cm or less"
  }
]; 
